import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=b9f34f9c&scoped=true&"
import script from "./Rankings.vue?vue&type=script&lang=js&"
export * from "./Rankings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f34f9c",
  null
  
)

export default component.exports